import { useMemo } from "react"
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { useProjetosHibridoStore } from "src/store/vendas/projetos/hibrido/hibrido.store"
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types"
import { PROPOSTA_OPTIONS } from "../../constants"

export const TipoPropostaInput = () => {
  const { tipo_proposta, recebe_servico, revenda, segmento } = useProjetosHibridoStore((store) => store.state.data)
  const { changeValue } = useProjetosHibridoStore((store) => store.actions)

  const tipoPropostaOptions = useMemo(()=>{
    if (!recebe_servico) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if (!revenda) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    if (!revenda?.segmentos_servico?.includes(segmento?.includes("on") ? "on" : "off")) return PROPOSTA_OPTIONS.filter(item => item.value === 'gerador-sem-instalacao')
    return PROPOSTA_OPTIONS
  },[recebe_servico, revenda, segmento]);

  return (
    <InputComboBoxList
      id={`select-proposta`}
      key={`select-proposta`}
      label={"* Tipo de proposta"}
      textField="text"
      valueField="value"
      disabled={tipoPropostaOptions.length <= 1 }
      options={tipoPropostaOptions}
      value={tipo_proposta}
      autoComplete
      renderOptions={(option: any) => {
        return `${option.text}`
      }}
      renderOptionsLabel={(option: any) => {
        return `${option.text}`
      }}
      onChange={(value: any) => {
        const limparServico = value ? value?.value === "gerador-sem-instalacao" : true

        const payload: Partial<FormProjetoHibridoType>  = {
          tipo_proposta: value,
        }

        if (limparServico) {
          payload.valor_servico = 0
          payload.valor_servico_pis_cofins = 0
        }

        changeValue(payload)
      }}
    />
  )
}